// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_ni-0";